import { UseFormReturnType } from '@mantine/form';

export function formHasFieldErrors<T>(form: UseFormReturnType<T>, ...rootFields: (keyof T)[]): boolean {
  // Get all root field names from error keys
  const errorRootFields = Object.keys(form.errors).map((errorKey) => {
    return errorKey.includes('.') ? errorKey.split('.')[0] : errorKey;
  });

  // Check if any of the passed fields match the error root fields
  return rootFields.some((field) => errorRootFields.includes(String(field)));
}
